import React from 'react'

import './Pickaxe.css'
import { Panel } from './Panel'
import disc from '../../images/ui/disc.png'
import hammer from '../../images/ui/hammer.png'
import poele from '../../images/ui/poele.png'

interface Props {
    onClick: () => void
    className?: string;
}
export const Pickaxe: React.FC<Props> = ({ className, onClick }) => {
    return (
        <div id="Updatebutton" className={`dig ${className || ''}`} onClick={onClick}>
            <div className="disc">
                <img src={disc} className="discBackground"/>
                <img src={poele}  className="pickaxe"/>

            </div>
            <Panel hasOuter={false}>
                <span id='upgrade'>
                    Upgrade
                </span>
            </Panel>

        </div>
    )
}
